export const numberFormat = (input: number | string, decimalDigit = 2) => {
  const number = typeof input === 'string' ? parseFloat(input) : input
  const hasDecimal = number % 1 !== 0

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: hasDecimal ? decimalDigit : 0,
    maximumFractionDigits: decimalDigit,
  }).format(number)
}

export const numberFormatWithPrecision = (
  input: number | string,
  precisionDigit = 2
) => {
  const number = typeof input === 'string' ? parseFloat(input) : input
  const numberValue = Number(number?.toPrecision(precisionDigit))

  return new Intl.NumberFormat('en-US').format(numberValue)
}
